import React from 'react';
import { pageContext } from 'ctm-util-functions';
import { ProgressBar as ManorProgressBar } from '@comparethemarketau/manor-progress';
import { DynamicComponent } from '../dynamic_component/dynamic_component';

const getProgressPercentage = () => {
    // store the path of the current route
    const currentLocation = pageContext.getProps().pageState.path;

    // get the journey schema object
    const journeyPages = pageContext.getProps().models.pageSchemaModel.getPageJourneyForProgressBar();
    // added + 1 to the logic to prevent an issue where the index of the first page is 0
    // so with the maths below it would equal 0% and the requirements asked to show a value greater than 0 on the first page
    const currentPageIndex = journeyPages.findIndex((currentPage) => currentPage.path === currentLocation) + 1;
    const totalPages = journeyPages.length;
    if (currentPageIndex + 1 === totalPages) {
        // requirement was to return 99% if its the last page before results
        // sometimes with the maths below would return 98% for example 4
        return 99;
    }
    return Math.round((currentPageIndex / totalPages) * 100);
};

const ProgressBar = (props) => {
    return <DynamicComponent component={<ManorProgressBar {...props} value={getProgressPercentage()} />} />;
};

export { ProgressBar };
